import { toSnakeCase } from '@/helpers';

export const formDataGenerator = (data, objectKey) => {
  // Generate FormData for api calls
  let object;
  data = toSnakeCase(data);
  if (objectKey.length > 0) {
    // If object needs to be wrapped in a specific key
    object = {};
    object[`${objectKey}`] = data;
  } else {
    object = data;
  }

  let formData = new FormData();

  const fillFormData = (obj, stringSubKey = '') => {
    for (let i in obj) {
      let value = obj[i];
      let subKeyToString = stringSubKey ? stringSubKey + '[' + i + ']' : i;

      if (typeof value === 'string' || typeof value === 'number' || value instanceof File) {
        formData.append(subKeyToString, value);
      } else if (typeof value === 'object') {
        fillFormData(value, subKeyToString);
      }
    }
  };

  fillFormData(object);

  return formData;
};
